import { embroideryUpdates, embroideryIssue } from '@theme/solvia-embroidery-cart-model';

let busy = false;
const root = window.Shopify.routes.root;
const markedRows = () => document.querySelectorAll('[data-embroidery-group]:not([data-embroidery-group=""])');

function showError(message) {
  let alert = document.querySelector('[data-embroidery-cart-error]');
  if (!alert) {
    alert = document.createElement('p');
    alert.dataset.embroideryCartError = '';
    alert.setAttribute('role', 'alert');
    (document.querySelector('cart-items-component') || document.querySelector('main')).prepend(alert);
  }
  alert.textContent = message;
  alert.tabIndex = -1;
  alert.focus();
}

async function readCart() {
  const response = await fetch(`${root}cart.js`, { cache: 'no-store' });
  if (!response.ok) throw new Error('カートを取得できませんでした。もう一度お試しください。');
  return response.json();
}

async function update(row, quantity) {
  if (busy) return;
  busy = true;
  document.querySelectorAll('cart-items-component').forEach((el) => el.setAttribute('aria-busy', 'true'));
  try {
    const cart = await readCart();
    const updates = embroideryUpdates(cart.items, row.dataset.key, quantity);
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }),
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status) throw new Error(result.description || result.message || '数量を変更できませんでした。');
    const issue = embroideryIssue(result.items);
    if (issue) throw new Error(issue);
    window.location.assign(`${root}cart`);
  } catch (error) {
    showError(`${error.message} カートを再読み込みして現在の数量をご確認ください。`);
  } finally {
    busy = false;
    document.querySelectorAll('cart-items-component').forEach((el) => el.removeAttribute('aria-busy'));
  }
}

document.addEventListener('quantity-selector:update', (event) => {
  const row = event.target.closest?.('[data-embroidery-group]');
  if (!row?.dataset.embroideryGroup && !busy) return;
  event.stopImmediatePropagation();
  if (row?.dataset.embroideryGroup) update(row, Number(event.detail.quantity));
}, true);

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('.cart-items__remove');
  if (!button) return;
  const row = button.closest('[data-embroidery-group]');
  if (!row?.dataset.embroideryGroup && !busy) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (row?.dataset.embroideryGroup) update(row, 0);
}, true);

async function checkout(event) {
  if (!markedRows().length) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (busy) return;
  busy = true;
  try {
    const cart = await readCart();
    const issue = embroideryIssue(cart.items);
    if (issue) throw new Error(issue);
    window.location.assign(`${root}checkout`);
  } catch (error) { showError(error.message); }
  finally { busy = false; }
}

document.addEventListener('click', (event) => {
  if (event.target.closest?.('[name="checkout"], a[href$="/checkout"]')) checkout(event);
}, true);
document.addEventListener('submit', (event) => {
  if (event.submitter?.name === 'checkout') checkout(event);
}, true);
